import { AlertOctagon, AlertTriangle, CheckCircle2, TriangleAlert } from 'lucide-react';

/**
 * PALETA STANU ZAPEŁNIENIA — JEDNA NA CAŁY PLANOGRAM.
 *
 * ⚠️ MIESZKA TU, A NIE W EKRANIE, I TO JEST POPRAWKA ZGŁOSZONEGO BŁĘDU: siatka i bęben miały
 * własne palety i ta sama przegródka wychodziła w dwóch kolorach — „puste komórki są na żółto,
 * gdy na siatce są na czerwono". Kolor jest znaczeniem, więc dwa znaczenia tej samej rzeczy
 * w dwóch widokach tego samego ekranu to błąd, a nie preferencja graficzna.
 *
 * Paleta jest ZAREZERWOWANA dla stanów: nigdy nie tematyzujemy jej pod motyw i zawsze idzie
 * z ikoną oraz etykietą, żeby wartość nie jechała samym kolorem.
 */
export const STOCK_STEPS = [
  { max: 0, key: 'stock.out', bg: 'var(--pg-critical)', ink: 'var(--pg-critical-ink)', icon: AlertOctagon },
  { max: 25, key: 'stock.low', bg: 'var(--pg-serious)', ink: 'var(--pg-serious-ink)', icon: AlertTriangle },
  { max: 50, key: 'stock.mid', bg: 'var(--pg-warning)', ink: 'var(--pg-warning-ink)', icon: TriangleAlert },
  { max: 100, key: 'stock.ok', bg: 'var(--pg-good)', ink: 'var(--pg-good-ink)', icon: CheckCircle2 },
] as const;

export function stockStep(fill: number) {
  return STOCK_STEPS.find((s) => fill <= s.max) ?? STOCK_STEPS[STOCK_STEPS.length - 1]!;
}

/** Przegródka BEZ przypisanego towaru — sam obrys, bo to informacja o planogramie, nie o zapasie. */
export const BEZ_TOWARU = { bg: 'transparent', ink: 'var(--pg-other-ink)', border: 'var(--pg-none-border)' };

/**
 * STAN KOMÓRKI WOBEC SZUKANEGO TOWARU — jeden podział dla siatki i dla bębna.
 *
 * ⚠️ TRZY STANY, NIE DWA. „Nikt nie szuka" musi być czymś innym niż „szuka, ale to nie ten
 * towar": w pierwszym przypadku wszystkie komórki wyglądają normalnie, w drugim reszta ma
 * zgasnąć. Zlanie ich w `boolean` dawało planogram wyblakły przy pustej wyszukiwarce.
 *
 * ⚠️ TO NIE JEST ZAZNACZENIE i nie może nim zostać — zaznaczenie decyduje o tym, co zrobi zapis.
 * Szukanie odpowiada wyłącznie na pytanie „gdzie to leży".
 */
export type StanSzukania = 'nieaktywne' | 'trafienie' | 'obok';

export function stanSzukania(c: { item: { id: string } | null }, szukany: string | null): StanSzukania {
  if (szukany === null) return 'nieaktywne';
  return c.item?.id === szukany ? 'trafienie' : 'obok';
}
